module.exports = __webpack_public_path__ + "static/media/pbg-3.e65d40db.svg";